var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graduation-cap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-4",
    transform: "translate(-796.000000, -511.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 198,
    transform: "translate(796.000000, 511.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.79652125,10.8982606 C0.804329959,10.402165 0.805987179,9.59700641 1.79652125,9.10173938 L11.0980496,4.45097518 C11.5961831,4.20190847 12.3992615,4.19963074 12.9019504,4.45097518 L22.2034788,9.10173938 C23.19567,9.59783502 23.1940128,10.4029936 22.2034788,10.8982606 L12.9019504,15.5490248 C12.4038169,15.7980915 11.6007385,15.8003693 11.0980496,15.5490248 L1.79652125,10.8982606 Z",
    id: "Path-129",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,12.5 L6,17.9986199 C6,18.5516669 6.42708635,19.1307325 6.96172553,19.2785558 C6.96172553,19.2785558 9,20 12,20 C15,20 17.0583801,19.2732544 17.0583801,19.2732544 C17.5784224,19.1223402 18,18.5532287 18,17.9986199 L18,12.5",
    id: "Path-130",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-101",
    fill: "currentColor",
    cx: 12,
    cy: 10,
    rx: 2,
    ry: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-131",
    stroke: "currentColor",
    strokeLinejoin: "round",
    points: "12 10 21.5 11 21.5 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-132",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "21.5 16 21 18 22 18"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.35d81b20d18208ab9a5b86c6b101f2bb.svg";
export { ForwardRef as ReactComponent };